import { ItemProvaDatasource } from "./UserData";

export class ProvaDados {
  instituicao: ItemProvaDatasource;
  banca: ItemProvaDatasource;
  ano: ItemProvaDatasource;
  tipo: ItemProvaDatasource;
  cargo: ItemProvaDatasource;
}
